export default __webpack_public_path__ + "static/media/2.3ad1a9ea.jpg";